import { FC } from "react"
import { OdResourcePageProps } from "@/types/resource"
import { Box } from "@mui/material"
import DataAccessTokenList from "./DataAccessTokenList"


const DataAccessPolicy: FC<OdResourcePageProps> = (props) => {
  return (
    <DataAccessPolicyBody {...props} />
  )
}

const DataAccessPolicyBody: FC<OdResourcePageProps> = ({
  options,
  resource,
}) => {
  
  return (
    <>
      <Box sx={{ mt: 4 }}>
        <DataAccessTokenList />
      </Box>
    </>
  )
}

export default DataAccessPolicy;
